import { SkeletonLoader } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledSkeletonLoader = styled(SkeletonLoader)`
  flex-grow: 1;
  padding: 16px;
`;
